import { render, staticRenderFns } from "./CollectFood.vue?vue&type=template&id=ffcf752a&scoped=true"
import script from "./CollectFood.vue?vue&type=script&lang=js"
export * from "./CollectFood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcf752a",
  null
  
)

export default component.exports